import { GET, DELETE, PUT, POST } from "Common/api";

const API_ACTIVITYCHECKLIST = "v1/activity/checklist/:activityId";
const API_TASKS = "v1/activity/checklist/:activityId/items";
const API_CHECKLISTSFORCOPYING = "v1/activity/:activityId/checklistsforcopying";
const API_COPYCHECKLIST = "v1/checklist/copy";
const API_DELETECHECKLIST = "v1/checklist/:id";
const API_ADDCHECKLISTITEM = "v1/checklistitemwithcheck";
const API_UPDATECHECKLISTITEM = "v1/checklistitem";
const API_DELETECHECKLISTITEM = "v1/checklistitem/:id";
const API_DELETECHECKLISTITEMS = "v1/checklistitems";
const API_SETITEMSTATUS = "v1/checklistitem/:checklistItemId/status";
const API_REMINDER = "v1/checklistitem/:checklistItemId/reminder";
const API_UPDATEREMINDER = "v1/checklistitemreminder";
const API_ADDREMINDER = "v1/checklistitemreminder";
const API_SENDTESTREMINDER = "v1/checklistitemreminder/send/:activityId";

export async function getActivityChecklist(activityId) {
  let tasks = await GET(API_ACTIVITYCHECKLIST, { activityId });
  return tasks;
}

export async function getChecklistItems(activityId) {
  let tasks = await GET(API_TASKS, { activityId });
  return tasks;
}

export async function getChecklistsForCopying(activityId) {
  let lists = await GET(API_CHECKLISTSFORCOPYING, { activityId });
  return lists;
}

export async function copyChecklist(objectId, type, checklistId, overwrite) {
  await POST(
    `${API_COPYCHECKLIST}?${new URLSearchParams({
      objectId,
      type,
      checklistId,
      overwrite,
    })}`,
  );
}

export async function deleteChecklist(checklistId) {
  await DELETE(API_DELETECHECKLIST, { id: checklistId });
}

export async function deleteChecklistItem(checklistItemId) {
  await DELETE(API_DELETECHECKLISTITEM, { id: checklistItemId });
}

export async function deleteChecklistItems(checklistItemIds) {
  const checklistItemQueryParams = new URLSearchParams();
  checklistItemIds.forEach((checklistItemId) => {
    checklistItemQueryParams.append("checklistItemIds", checklistItemId);
  });

  await DELETE(`${API_DELETECHECKLISTITEMS}?${checklistItemQueryParams}`);
  return "";
}

export async function setChecklistItemStatus(checklistItemId, completed) {
  await PUT(`${API_SETITEMSTATUS}?completed=${completed}`, {
    checklistItemId,
  });
}

export async function addChecklistItem(checklistItem, activityId, type) {
  let response = await POST(
    `${API_ADDCHECKLISTITEM}?${new URLSearchParams({
      objectId: activityId,
      checklistType: type,
    })}`,
    {},
    checklistItem,
  );

  let updatedData = Object.assign({}, checklistItem);
  if (response) {
    updatedData.checklistItemID = response;
    return updatedData;
  } else {
    updatedData.checklistItemID = Math.floor(Math.random() * Math.floor(10000));
    return updatedData;
  }
}

export async function updateChecklistItem(checklistItem) {
  await PUT(API_UPDATECHECKLISTITEM, {}, checklistItem);
  return "ok";
}

export async function getReminder(checklistItemId) {
  let reminder = await GET(API_REMINDER, { checklistItemId });
  return reminder;
}

export async function addReminder(reminder) {
  let response = await POST(API_ADDREMINDER, {}, reminder);
  if (response) {
    let updatedData = Object.assign({}, reminder);
    updatedData.checklistItemReminderId = response;
    return updatedData;
  }
  return reminder;
}

export async function updateReminder(reminder) {
  await PUT(API_UPDATEREMINDER, {}, reminder);
}

export async function sendTestReminder(checklistItem, activityId) {
  let response = await POST(
    API_SENDTESTREMINDER,
    { activityId },
    checklistItem,
  );
  return response;
}

/*Checklistitem object


        public string Title 
        public string Description
        public int? ChecklistID { get; set; }
        public int Type  (Ska vara 2 när det är ett kurstillfälle)
        public int? Id 
        public int? ChecklistItemID 
        public int? CourseID 
        public int? CourseObjectID 
        public DateTime? Deadline 
        public int? DeadlineID
        public string Link 
        public string LinkLabel 
        public int Priority 
        public int ItemOrder
        public int ObjectId
        public bool Completed
        public string CompletedBy 
        public string CompletedName 
        public DateTime? CompletedDate
    */

/* ChecklistItemReminder object
    {
        public int ChecklistItemId 
        public int ChecklistItemReminderId 
        public string Subject

        public DateTime ReminderDate 
        public string RelativeReminder
        public int ReminderType  (0=ingen, 1=relativt, 2=datum)
        public string EmailAddresses
    */
